export const completeWorkOrder = (orderId: string) => {
	return {
		method: "PUT",
		url: `${process.env.REACT_APP_ORIGIN}/work_order_utility/complete-work-order`,
		body: orderId,
	}
}
